import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PageModel } from "@app/models/page.model";
import { GoodSpecificationsResponse, ReserveGoodResponse } from "@app/ui_models/web-response";
import { env } from "@environments/environment";
import { GoodsLovControlDateDto } from "@app/ui_models/model-dto";

@Injectable({ providedIn: "root" })
export class ReserveController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;
  protected baseUrl = `${env.logisticsServiceBackend}/logistics/v1/reserve`;

  public retrieveDistributionGoodsSpec(params: HttpParams): Observable<PageModel<GoodSpecificationsResponse>>  {
    return this.httpService.get(`${this.baseUrl}/specifications`, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public retrieveReserveGoods(params: HttpParams): Observable<PageModel<ReserveGoodResponse>>  {
    return this.httpService.get(`${this.baseUrl}/mnngoods`, { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public updateDateForLovIds(goodsLovControlDateDto: GoodsLovControlDateDto): Observable<any> {
    const headers = new HttpHeaders().set("Content-type", "application/json");
    return this.httpService
      .post(`${this.baseUrl}/loveIds/update`, JSON.stringify(goodsLovControlDateDto), { headers, responseType: "text" })
      .pipe(map(res => (res ? JSON.parse(res) : undefined)));

  }

}
